import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Grid, Paper, Typography, Button, Box,
  FormControl, Select, MenuItem, InputLabel
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "../../config/action-config";
import useCaseList from "../../hooks/useCaseList";

export default function DisputeItemsHome() {

  // return <></>
  const dispatch = useDispatch();
  const [chosenOne, setChosenCase] = useState("");
  const cases = useSelector(state => state.cases);

  const { caseList, selectedCaseId, setSelectedCaseId } = useCaseList();

  useEffect(() => {
    if(cases.selected.id)
    setChosenCase(cases.selected.id)
  }, [cases.selected]);

  const onSelectedCaseChange = ({target}) => {
    setChosenCase(target.value);
    setSelectedCaseId(target.value);
    dispatch({ type: caseActions.SELECT, payload: { id: target.value } })
  }

  return (
    <>
       <Paper className="odr-card">
        <Box display="flex" justifyContent="space-between" className="odr-card-header">
          <Typography className="heading-title">Choose A Case</Typography>
        </Box>
        <Box px={2} pb={4}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl required fullWidth size='small' varaint="outlined">
                <InputLabel id="demo-simple-select" >Case</InputLabel>
                <Select
                  variant='outlined'
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="id"
                  value={''+selectedCaseId}
                  label="Case"
                  onChange={onSelectedCaseChange}
                >
                  <MenuItem value="">Select</MenuItem>
                  {
                    caseList.map((c, i) => <MenuItem key={i} value={c.id}>{c.title}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </Grid>
            {
              Boolean(selectedCaseId) ? <Grid item xs={12} md='auto' lg='auto'>
                <Box display='flex' columnGap={1}>
                  <Link to={`${selectedCaseId}`}>
                    <Button color="primary" variant="contained" size="large" className="blue-button">See Dispute Items</Button>
                  </Link>
                  {/* <Link to={`${selectedCaseId}/new`}>
                    <Button color="secondary" variant="contained">Upload Documents</Button>
                  </Link> */}
                </Box>
              </Grid> : <></>
            }
          </Grid>
        </Box>
      </Paper>
    </>
  )
}
